import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const PanelCacheContext = createContext(null);

const initialState = {
  users: { results: [], showSearch: true },
  athlete: { results: [], showSearch: true },
  plans: { results: [], showSearch: true },
  philosophies: { list: [], showSearch: true },
  personas: { list: [] },
  globalWorkouts: { results: [], showSearch: true },
  personalWorkouts: { results: [], showSearch: true },
  promptRuns: { results: [], showSearch: true },
  ongoingJobs: { results: [], showSearch: true },
  nudges: { results: [], showSearch: true },
  killSwitch: { config: null },
  messagingEndpoints: { results: [], selectedUser: null },
  smsConversations: { results: [], showSearch: true },
  smsPending: { results: [], showSearch: true },
  smsMessages: { results: [], showSearch: true },
};

export function PanelCacheProvider({ children }) {
  const [cache, setCache] = useState(initialState);

  const updateCache = useCallback((key, data) => {
    setCache((prev) => ({ ...prev, [key]: { ...prev[key], ...data } }));
  }, []);
  const value = useMemo(() => ({ cache, updateCache }), [cache, updateCache]);

  return (
    <PanelCacheContext.Provider value={value}>
      {children}
    </PanelCacheContext.Provider>
  );
}

export function usePanelCache(key) {
  const ctx = useContext(PanelCacheContext);
  if (!ctx) throw new Error("usePanelCache must be used within PanelCacheProvider");
  const { cache, updateCache } = ctx;
  const panelState = cache[key] || {};
  const setPanelState = useCallback((data) => updateCache(key, data), [updateCache, key]);
  return [panelState, setPanelState];
}
